//@flow
import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import { makeStyles } from '@material-ui/core/styles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import AccountCircle from '@material-ui/icons/AccountCircle'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'

import { Link } from 'react-router-dom'
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from 'material-ui-popup-state/hooks'
import { useStore } from '../../store/useStore'
import ThemeToggle from '../ThemeToggle'
import * as genericApis from '@lesofi/phoenix-js/lib/phoenixgoapi/generic'

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: 'rgba(71, 85, 105, 0.85)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    animation: '$slideDown 0.5s ease-out',
  },
  '@keyframes slideDown': {
    from: {
      opacity: 0,
      transform: 'translateY(-20px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  toolbar: {
    minHeight: 64,
  },
  icon: {
    marginRight: theme.spacing(2),
  },
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.1)',
      background: 'rgba(212, 175, 55, 0.1)',
    },
  },
  title: {
    flexGrow: 1,
    background: 'linear-gradient(135deg, #CA9A2C 0%, #F3C817 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textDecoration: 'none',
    fontFamily: '"Outfit", sans-serif',
    fontWeight: 700,
    fontSize: '1.5rem',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    letterSpacing: '0.02em',
    textShadow: '0 0 30px rgba(212, 175, 55, 0.3)',
    "&:hover": {
      textDecoration: 'none',
      filter: 'brightness(1.2)',
    }
  },
  accountButton: {
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.1)',
      background: 'rgba(212, 175, 55, 0.15)',
    },
  },
  accountIcon: {
    fontSize: '1.8rem',
    color: theme.palette.primary.light,
    filter: 'drop-shadow(0 0 8px rgba(212, 175, 55, 0.4))',
  },
  menu: {
    '& .MuiPaper-root': {
      background: 'rgba(71, 85, 105, 0.95)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      border: '1px solid rgba(212, 175, 55, 0.2)',
      borderRadius: 12,
      marginTop: theme.spacing(1),
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
    },
  },
  menuItem: {
    color: theme.palette.text.primary,
    padding: theme.spacing(1.5, 3),
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      background: 'rgba(212, 175, 55, 0.15)',
      transform: 'translateX(4px)',
    },
  },
}))

function AppHeader() {
  const classes = useStyles();
  const popupState = usePopupState({ variant: 'popover', popupId: 'userProfileMenu' })

  const { state, dispatch } = useStore()
  const logout = React.useCallback(() => {
    genericApis.appUserLogoutApi()
      .then(res => {
        // Always dispatch logout to clear client state, regardless of server response
        dispatch({ type: "logout" })

        // Optionally handle specific error statuses
        if (res.status !== 200) {
          console.warn('Logout API returned non-200 status:', res.status)
        }
      })
      .catch(err => {
        console.error('Logout API error:', err)
        // Still dispatch logout to clear client state
        dispatch({ type: "logout" })
      })
  }, [dispatch]);

  const handleLogout = () => {
    popupState.close()
    logout()
  }

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar} elevation={0}>
        <Toolbar className={classes.toolbar}>
          <Typography
            variant="h6"
            className={classes.title}
            component={Link} to='/'
          >
            Gigsdata
          </Typography>
          <div style={{ flex: 1 }} />
          <ThemeToggle />
          {state.user.loggedIn ? (
            <div>
              <IconButton
                aria-label="userProfileMenu"
                aria-haspopup="true"
                className={classes.accountButton}
                {...bindTrigger(popupState)}
              >
                <AccountCircle className={classes.accountIcon} />
              </IconButton>
              <Menu {...bindMenu(popupState)} className={classes.menu}>
                <MenuItem className={classes.menuItem} component={Link} to='/profile' >Profile</MenuItem>
                <MenuItem className={classes.menuItem} onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </div>
          ) : null}
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default React.memo < {} > (AppHeader)